module.exports = __webpack_public_path__ + "static/img/logo.d4a32395.jpg";